import {
  kycRedirectRequestSchema,
  kycRedirectResponseSchema,
  kycResponseSchema,
  kycVerifyRequestSchema,
  webidStartRequestSchema,
} from 'xosign-types';

import { z } from 'zod';
import { API_URL_BASE } from '@/config';
import { type EndpointDefinition } from '@/types/endpointTypes';

const endpoints = {
  'kyc.init': {
    method: 'POST',
    url: `${API_URL_BASE}kyc/init`,
    requestSchema: kycRedirectRequestSchema,
    responseSuccessSchema: kycRedirectResponseSchema,
    requiresToken: 'local',
    responseErrorSchemas: z.undefined(),
  } satisfies EndpointDefinition<
    typeof kycRedirectRequestSchema,
    typeof kycRedirectResponseSchema,
    z.ZodUndefined
  >,
  'kyc.verify': {
    method: 'POST',
    url: `${API_URL_BASE}kyc/verify`,
    requestSchema: kycVerifyRequestSchema,
    responseSuccessSchema: kycResponseSchema,
    requiresToken: 'local',
    responseErrorSchemas: z.undefined(),
  } satisfies EndpointDefinition<
    typeof kycVerifyRequestSchema,
    typeof kycResponseSchema,
    z.ZodUndefined
  >,
  'webid.init': {
    method: 'POST',
    url: `${API_URL_BASE}webid/kyc/init`,
    requestSchema: webidStartRequestSchema,
    responseSuccessSchema: kycRedirectResponseSchema,
    requiresToken: 'local',
    responseErrorSchemas: z.undefined(),
  } satisfies EndpointDefinition<
    typeof webidStartRequestSchema,
    typeof kycRedirectResponseSchema,
    z.ZodUndefined
  >,
};

export default endpoints;
